/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PropertyTypeItem
 */
export interface PropertyTypeItem {
    /**
     * 
     * @type {number}
     * @memberof PropertyTypeItem
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PropertyTypeItem
     */
    propertyType: string;
}

/**
 * Check if a given object implements the PropertyTypeItem interface.
 */
export function instanceOfPropertyTypeItem(value: object): value is PropertyTypeItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('propertyType' in value) || value['propertyType'] === undefined) return false;
    return true;
}

export function PropertyTypeItemFromJSON(json: any): PropertyTypeItem {
    return PropertyTypeItemFromJSONTyped(json, false);
}

export function PropertyTypeItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyTypeItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'propertyType': json['propertyType'],
    };
}

export function PropertyTypeItemToJSON(json: any): PropertyTypeItem {
    return PropertyTypeItemToJSONTyped(json, false);
}

export function PropertyTypeItemToJSONTyped(value?: PropertyTypeItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'propertyType': value['propertyType'],
    };
}

